﻿
$(document).ready(function () {

    var faq = $("#faq");
    if (!faq) return;

    // collapse all accordions
    $('.collapse', faq).collapse();

    //set first button to selected on startup
    var generalFAQ = $(".faq-button", faq).first();

    if (!generalFAQ.length) return;
    generalFAQ.addClass("selected");

    //hide non-selected accordions on startup
    $(".accordion").hide()
    $(".accordion#" + generalFAQ.text()).show();

    $(".accordion-button", faq).each(function () {
        if (!$(this).hasClass("collapsed")) {
            $(this).find(".expand-accordion").hide();
        }

        $(this).click(function () {
            $(this).parents(".card").siblings().find(".expand-accordion").show();
            $(this).find(".expand-accordion").toggle();
        });
    });

    //set toggle for faq buttons to show or hide related accordion
    $(".faq-button", faq).click(function () {
        $(this).siblings().removeClass("selected");
        $(this).addClass("selected");
        var accordionID = $(this).text();

        $(".accordion", faq).hide()
        $(".accordion#" + accordionID, faq).show();
    });
});

